import React from 'react';

export const CountriesPrefsSelector = ({ countriesPrefs, currentPrefId }) => {
  const countriesPrefSelect = countriesPrefs.map((countriesPref) => {
    return (
      <option value={countriesPref.id} key={countriesPref.id}>
        {countriesPref.name}
      </option>
    );
  });

  const updatePrefId = async (prefId) => {
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');

      const response = await fetch('/api/user/set_pref_id', {
        method: 'POST',
        body: JSON.stringify({ pref_id_1: prefId }),
        headers,
      });

      if (!response.ok) {
        alert('都道府県の更新に失敗しました。');
      }
    } catch (e) {
      alert('通信に失敗しました。')
    }
  };

  return (
    <div className="container col-md-8 col-lg-6 mb-5">
      <h6 className="text-fz-16px text-fw-bold text-left mt-5 pb-2">
        お住まいの都道府県
      </h6>
      <select
        className="form-control"
        onChange={(e) => updatePrefId(e.target.value)}
        defaultValue={currentPrefId ?? 0}
      >
        <option value={0} key={0}>
          選択してください
        </option>
        {countriesPrefSelect}
      </select>
    </div>
  );
};